import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../helpers/utility";

const initialState = {
	posts: [
		{
			id: 0,
			name: "Total Calls",
			value: "00",
		},
		{
			id: 1,
			name: "Total Call Time",
			value: "00:00:00",
		},
		{
			id: 2,
			name: "Total Pause Time",
			value: "00:00:00",
		},
		{
			id: 3,
			name: "Total Wrap Time",
			value: "00:00:00",
		},
	],
	dispositions: [],
	agentBreaks: [],
	error: null,
	loading: false,
};

const callDataStart = (state, action) => {
	return updateObject(state, { loading: true });
};

const callDataSuccess = (state, action) => {
	return updateObject(state, {
		posts: action.posts,
		dispositions: action.dispositions,
		agentBreaks: action.agentBreaks,
		loading: false,
	});
};

const callDataUpdate = (state, action) => {
	return updateObject(state, {
		posts: action.posts,
		dispositions: action.dispositions,
		agentBreaks: action.agentBreaks,
		error: null,
		loading: false,
	});
};

const callDataFail = (state, action) => {
	return updateObject(state, { error: action.error, loading: false });
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.CALL_INFO_START:
			return callDataStart(state, action);
		case actionTypes.CALL_INFO_SUCCESS:
			return callDataSuccess(state, action);
		case actionTypes.CALL_INFO_FAIL:
			return callDataFail(state, action);
		case actionTypes.CALL_INFO_UPDATE:
			return callDataUpdate(state, action);
		default:
			return state;
	}
};

export default reducer;
